import { head } from 'lodash/fp';
import { useQuery } from '@apollo/client';

import { ExplainedTerm } from '../../../../../types/__codegen__/sanity/graphql';
import GET_EXPLAINED_TERM from '../../queries/get-explained-term';
import uniqueContentWithDraftPrecedence from '../../../../../cms/utils/unique-content-with-draft-precedence';

type UseGetExplainedTerm = {
  skip?: boolean;
  slug: string;
};

const useGetExplainedTerm = ({ skip = false, slug }: UseGetExplainedTerm) => {
  const { called, data, loading, error } = useQuery(GET_EXPLAINED_TERM, {
    skip,
    variables: { slug },
  });

  return {
    error,
    explainedTerm: head(uniqueContentWithDraftPrecedence(data?.allExplainedTerm)) as ExplainedTerm,
    hasErrors: Boolean(error),
    isLoading: !called || loading,
  };
};

export default useGetExplainedTerm;
